// This is all just to get around circular dependencies. If using `new TreeNode`
// and `new TreeNodeList` gives such an error, use these functions instead.
export let newTreeNode;
export let newTreeNodeList;
/**
 * Setup the functions that make new TreeNodes and TreeNodeLists. This is
 * necessary to avoid circular dependencies.
 *
 * @param  {Function} makeNode      The function that makes new TreeNodes.
 * @param  {Function} makeNodeList  The function that makes new TreeNodeLists.
 */
export function setupMakerFuncs(makeNode, makeNodeList) {
    newTreeNode = makeNode;
    newTreeNodeList = makeNodeList;
}
